//* Libraries imports
import { motion } from 'framer-motion';
import { Card, Button } from 'react-bootstrap';

//* Components imports
import Icon from "../../../../components/common/Icon";

//* Icons imports
import { MdDescription, MdInfo, MdRefresh } from 'react-icons/md';
import { BsExclamationTriangle } from 'react-icons/bs';

//* Styles imports
import './edital-empty-state.scss';

type EditalEmptyStateProps = {
  onRefresh?: () => void;
}

export function EditalEmptyState({ onRefresh }: EditalEmptyStateProps) {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <motion.div
      className="container-fluid px-3 py-4"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
    >
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8 col-xl-6">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <Card className="shadow-lg edital-empty-card text-center">
              <Card.Body className="p-5">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ 
                    duration: 0.6, 
                    delay: 0.6,
                    type: "spring",
                    stiffness: 200 
                  }}
                  className="mb-4"
                >
                  <div className="empty-icon-wrapper">
                    <Icon 
                      icon={MdDescription} 
                      size={60} 
                      className="text-muted empty-icon"
                    />
                    <div className="warning-badge">
                      <Icon 
                        icon={BsExclamationTriangle} 
                        size={20} 
                        className="text-warning"
                      />
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.8 }}
                >
                  <h3 className="text-muted mb-3">Edital Não Disponível</h3>
                  <p className="text-muted mb-4 lead">
                    O edital para este processo seletivo ainda não foi publicado 
                    ou não contém regras específicas no momento.
                  </p>

                  <div className="alert alert-info d-flex align-items-center" role="alert">
                    <Icon icon={MdInfo} className="me-2" size={20} />
                    <div className="text-start">
                      <strong>O que fazer?</strong>
                      <div className="mt-1">
                        • Verifique se o processo seletivo já foi iniciado<br/>
                        • Entre em contato com a instituição para mais informações<br/>
                        • Tente atualizar a página em alguns minutos
                      </div>
                    </div>
                  </div>

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Button
                      variant="outline-primary"
                      size="lg"
                      onClick={handleRefresh}
                      className="d-flex align-items-center gap-2 mx-auto"
                    >
                      <Icon icon={MdRefresh} size={18} />
                      Atualizar Página
                    </Button>
                  </motion.div>
                </motion.div>
              </Card.Body>
            </Card>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
